module.exports = __webpack_public_path__ + "img/colors-select-icon.9eb9f316.png";